import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import HandOverReleaseCommsCalenderDialog from "./HandOverReleaseCommsCalenderDialog";
import { HANDOVER_DIALOGUES } from "./Constants";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 653,
  },
})(Dialog);

class HandOverReleaseCommsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkBoxSelected: false,
    };
  }

  handleClose = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.RELEASE_COMMS,
      HANDOVER_DIALOGUES.RELEASE_COMMS
    );
  };

  handleNext = () => {
    this.props.handleDialogChange(
      HANDOVER_DIALOGUES.RELEASE_COMMS_CALENDER,
      HANDOVER_DIALOGUES.RELEASE_COMMS
    );
  };

  confirmText = () => {
    this.setState((prevState) => ({
      checkBoxSelected: !prevState.checkBoxSelected,
    }));
  };

  render() {
    return (
      <>
        {this.props.open ? (
          <StyledDialog open={this.props.open} onClose={this.handleClose}>
            <div className={styles.dialog}>
              <Grid
                container
                data-testid="handOverReleaseCommsDialog"
                className={styles.dialogContainer}
                justify="center"
              >
                <Grid item md={12} className={styles.cancel}>
                  <div>
                    <button
                      data-testid="handOverReleaseCommsCloseDialog"
                      onClick={this.handleClose}
                    >
                      <StyledClear />
                    </button>
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.brightRedTitle}>
                    <div className={styles.warning} />
                    {this.props.t("HandOverReleaseCommsDialog.title")}
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.body}>
                    <div className={styles.text}>
                      {this.props.t("HandOverReleaseCommsDialog.bodyText1")}
                    </div>
                    <div className={styles.text}>
                      {this.props.t("HandOverReleaseCommsDialog.bodyText2")}
                    </div>
                    <ul>
                      <li className={styles.bold}>
                        {this.props.t("HandOverReleaseCommsDialog.bodyBullet1")}
                      </li>
                      <li>
                        {this.props.t("HandOverReleaseCommsDialog.bodyBullet2")}
                      </li>
                      <li>
                        {this.props.t("HandOverReleaseCommsDialog.bodyBullet3")}
                      </li>
                      <li>
                        {this.props.t("HandOverReleaseCommsDialog.bodybullet4")}
                      </li>
                      <li>
                        {this.props.t("HandOverReleaseCommsDialog.bodyBullet5")}
                      </li>
                      <li>
                        {this.props.t("HandOverReleaseCommsDialog.bodyBullet6")}
                      </li>
                    </ul>
                  </div>
                  <div className={styles.paddingTop}>
                    <CheckBox
                      id="chkBoxConfirm"
                      boldCheck={true}
                      checked={this.state.checkBoxSelected}
                      label={this.props.t(
                        "HandOverReleaseCommsDialog.confirmText"
                      )}
                      onChange={this.confirmText}
                      textClass={styles.chkBoxConfirm}
                    />
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.dialogActions}>
                    <Button
                      className={styles.cancel}
                      name="handOverReleaseCommsCancel"
                      data-testid="handOverReleaseCommsCancel"
                      onClick={this.handleClose}
                    >
                      {this.props.t("HandOverReleaseCommsDialog.cancel")}
                    </Button>
                    <Button
                      className={styles.next}
                      name="handOverReleaseCommsNext"
                      data-testid="handOverReleaseCommsNext"
                      disabled={!this.state.checkBoxSelected}
                      onClick={this.handleNext}
                    >
                      {this.props.t("HandOverReleaseCommsDialog.next")}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </StyledDialog>
        ) : (
          ""
        )}
        <HandOverReleaseCommsCalenderDialog
          {...this.props}
          todayDate={this.props.customerReservation.todayDate}
          open={
            this.props.dialogBoxes[HANDOVER_DIALOGUES.RELEASE_COMMS_CALENDER]
          }
        />
      </>
    );
  }
}

export default withTranslation("emp")(HandOverReleaseCommsDialog);
